// src/pages/RE/REG920F2.jsx 무작위 부여군 생성

import React, {useEffect, useState} from 'react';
import {postData} from "utils/TransactionUtil";
import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table"
import style from "../RE/REG920F1.module.scss";
import InputUnitText from "components/InputText/InputUnitText";
import toast from "../../components/Toast/Toast";
import Button from "../../components/Button/Button";


const REG920F2 = ({handle_Close,randId, randGrp, randIdNm, comHandleClick_Save}) => {


    const [dsMapObj,setDsMapObj] = useState([]);
    const [schParam, setSchParam] = useState({randId:randId, randGrp:randGrp});


    //데이터 get, set
    const getMapValue = (sno, column='mapId') =>{
        const entry = dsMapObj.find(
            (item) => item.randId === randId && item.randGrp === randGrp && item.randSno === sno
        );
        return entry ? entry[column] : "";
    }

    const setMapValue = (sno, value,colName='mapId') => {
        setDsMapObj(prevData =>
            prevData.map(item =>
                item.randSno === sno? { ...item, [colName]:value } : item
            )
        );
    };


    //form load
    useEffect(() => {
        getSchRandomMap();
    }, []);

    // useEffect(() => {
    //     //(공통) 모달 창 "확인(적용)" 버튼 클릭
    //     comHandleClick_Save(() => {
    //         handleClick_updateMapId();
    //
    //     });
    // }, [comHandleClick_Save]);

    const handleClick_updateMapId = () => {
        if(validateSaveObj()){
            svcCheckForUpdate();
        }
    }

    /* 체크  ====================================================================================================*/

    const validateSaveObj = () => {
        //const chkSaveObj = dsMapObj;
        let errMsg = "";

        // sno 기준으로 정렬
        const sortedList = [...dsMapObj].sort((a, b) => a.randSno - b.randSno);

        let lastValidSno = 0;
        const idSet = new Set(); // 중복 체크용 Set

        //mapId가 하나도 입력되지 않은 경우 체크
        const hasAnyMapId = sortedList.some(obj => obj.mapId?.trim() !== '');
        if (!hasAnyMapId) {
            errMsg = '연구 등록번호를 입력하여 주세요.';
            toast({ type: 'warning', message: errMsg });
            return false;
        }

        for (let i = 1; i <= 30; i++) {
            const item = sortedList.find(obj => obj.randSno === i);
            const hasId = item?.mapId?.trim() !== '';

            if (hasId) {
                // 중간 누락 체크
                if (i !== lastValidSno + 1) {
                    for (let missing = lastValidSno + 1; missing < i; missing++) {
                        errMsg = `${missing}번의 연구 등록번호가 누락되었습니다.`;
                        toast({ type: 'warning', message: errMsg });
                        return false;
                    }
                }
                lastValidSno = i;

                // id 형식 체크
                if (!/^\d{8}$/.test(item.mapId)) {
                    errMsg = `8자리 숫자만 입력 가능합니다.[${item.randSno}번]`;
                    toast({ type: 'warning', message: errMsg });
                    return false;
                }

                // id 중복 체크
                if (idSet.has(item.mapId)) {
                    errMsg = `[${item.mapId}] 중복된 연구번호 입니다.`;
                    toast({ type: 'warning', message: errMsg });
                    return false;
                }
                idSet.add(item.mapId);
            }
        }

        return true;
    };




    /* Call Service====================================================================================================*/

    async function getSchRandomMap() {

        let result = await postData("/REW/getSchRandomMap", schParam);
        setDsMapObj(result);

    }

    async function svcCheckForUpdate() {
        //업데이트 전 체크

        let result = await postData("/REW/getCheckForMapId", dsMapObj);
        if(result.length>0){
            alert("다른 곳에서 등록된 번호입니다.\n ID: " + result[0].randId + '/ 그룹: ' + result[0].randGrp + '/ 연구등록번호: ' + result[0].mapId )
        }{
            svcUpdateRandMapUser();
        }

    }

    async function svcUpdateRandMapUser() {
        //매핑정보 업데이트

        let result = await postData("/REW/updateRandMapUser", dsMapObj);
        toast({ type: 'info', message: '적용이 완료되었습니다.'});
        handle_Close();

    }

    const numbers = Array.from({ length: 30 }, (_, i) => i + 1);

    return(
        <main>
            <div className={styleCom.title_wrap} style={{marginLeft: "20px", color: "gray"}}>
                * 중복입력은 불가합니다(순서대로 입력하여 주세요)
            </div>
            <table className={style.info_table}
                   style={{height: "42px", marginBottom: "-10px", marginLeft: "20px", width: "96%"}}>
                <tbody>
                <tr>
                    <td className={style.info_text_1}> 아이디</td>
                    <td className={style.info_text_2}>{randId}</td>
                    <td>
                        <div className={style.verticalLine}/>
                    </td>
                    <td className={style.info_text_1}> 성명</td>
                    <td className={style.info_text_2}>{randIdNm}</td>
                    <td>
                        <div className={style.verticalLine}/>
                    </td>
                    <td className={style.info_text_1}> 랜덤그룹</td>
                    <td className={style.info_text_2}> {randGrp}</td>
                </tr>
                </tbody>
            </table>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={10} colSize={['20%', '50%', '20%', '50%', '20%', '50%']}
                       rowSize={'50px'}>
                    {numbers.map((num) => (
                        <React.Fragment key={num}>
                            <div>{num}</div>
                            <div>[ {getMapValue(num, 'randIndex')} ]
                                <InputUnitText
                                    type="text" value={getMapValue(num)}
                                    maxLength={8}
                                    onChange={(value) => setMapValue(num, value)}
                                />
                            </div>
                        </React.Fragment>
                    ))}

                </Table>
            </div>
            <div style={{display: "flex", justifyContent: "center", gap: "20px"}}>
                <Button variant="Tertiary" size="xl" addStyle={{width: "300px", height: "50px"}}
                        onClick={handle_Close}>
                    취소
                </Button>
                <Button variant="Primary" size="xl" addStyle={{width: "300px", height: "50px"}}
                        onClick={handleClick_updateMapId}>
                    저장
                </Button>
            </div>

        </main>
    )
}
export default REG920F2;